<template>
  <div class="modal fade" id="view-document" aria-hidden="true" aria-labelledby="exampleGrid" role="dialog">
    <div class="modal-dialog modal-simple modal-center">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container">
            <div class="row header">
              <div class="col-8">
                <h4 class="modal-title">
                  {{ $t("booking.detail.resources.view_document_modal.title") }}
                </h4>
              </div>
              <div class="col-4">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="closeModal('#view-document')">
                  <span aria-hidden="true" class="close-btn">&times;</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row d-flex justify-content-center align-items-center document-image">
            <div class="col-8">
              <img :src="resource.name" alt="">
            </div>
          </div>
        </div>
        <div class="modal-footer text-center">
          <a :href="resource.name" target="_blank" class="btn btn-primary waves-effect waves-classic">{{$t("booking.detail.resources.view_document_modal.view_original")}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import mixin from "../../../../mixins/mixin";

    export default {
        name: "ViewDocumentModal",
        props: [
          'resource'
        ],
        mixins: [mixin]
    }
</script>



// WEBPACK FOOTER //
// ViewDocumentModal.vue?1d57184f